import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=67fad1c9"
import script from "./Highlights.vue?vue&type=script&lang=ts"
export * from "./Highlights.vue?vue&type=script&lang=ts"
import style0 from "./Highlights.vue?vue&type=style&index=0&id=67fad1c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports